import { Outlet } from "react-router-dom";
import styles from "./LoginLayout.module.scss";
import { RiArrowLeftLine } from "@remixicon/react";

const LoginLayout: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.header}>
          <button
            className={styles.backButton}
            onClick={() => {
              window.location.href = "/wallet";
            }}
          >
            <RiArrowLeftLine />
          </button>
        </div>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LoginLayout;
